/** Admin: a vending machine's equipment configuration (controller, relay / credit pulses, Advanced actions) for an owner — twin of the owner Edit Equipment screen (Nathan 10-18). */
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { useLocalSearchParams, Stack } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import ContentContainer from '../../../../../src/components/ContentContainer';
import BayEquipmentConfig from '../../../../../src/components/bay/BayEquipmentConfig';
import { spacing } from '../../../../../src/utils/theme';

export default function AdminOwnerVendingEquipmentScreen() {
  const { id, machineId, machineName } = useLocalSearchParams<{ id: string; machineId: string; machineName?: string }>();
  return (
    <OwnerScopeProvider ownerId={id ?? null}>
      <Stack.Screen options={{ title: machineName ? `${machineName} · Equipment` : 'Vending Equipment' }} />
      <ScrollView contentContainerStyle={styles.scroll}>
        <ContentContainer>
          <BayEquipmentConfig bayId={machineId ?? ''} bayType="vending" apiBase={`/api/vending-machines/${machineId}`} />
        </ContentContainer>
      </ScrollView>
    </OwnerScopeProvider>
  );
}

const styles = StyleSheet.create({ scroll: { padding: spacing.lg } });
